<template>
  <BlockUI :blocked="proc">
    <ol class="page-breadcrumb breadcrumb">
      <router-link to="/" class="breadcrumb-item"> Dashboard </router-link>
      <router-link to="/profitandloss" class="breadcrumb-item textdecorationnone">
        <span class="colorbase">Profit & Loss</span>
      </router-link>
      <router-link to="/statement" class="breadcrumb-item">
        <span>My Stmt.</span>
      </router-link>
      <router-link to="/ledgers" class="breadcrumb-item">
        <span>Company Ledgers</span>
      </router-link>
      <router-link to="/collectionReport" class="breadcrumb-item">
        <span>Collection Report</span>
      </router-link>
      <router-link to="/liveGames" class="breadcrumb-item">
        <span>Live Matches</span>
      </router-link>
      <router-link to="/settledGames" class="breadcrumb-item">
        <span>Settled Matches</span>
      </router-link>
    </ol>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <MultiSelect v-model="sel" :options="sps" optionLabel="b" placeholder="Select Sports" style="width: 100%" />
      </div>
      <div class="col-sm-12 col-md-6">
        <!-- :dark="true"  -->
        <Datepicker v-model="date" range style="width: 100%" maxRange="60" :presetRanges="presetRanges" :datePicker="true" :max-date="maxd" teleport-center auto-apply>
          <template #yearly="{ label, range, presetDateRange }">
            <span @click="presetDateRange(range)">{{ label }}</span>
          </template>
        </Datepicker>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="d-grid gap-2">
          <Button label="Load" class="btn btn-grd btn-grd-deep-blue btn-sm" v-on:click="getpl()" />
        </div>
      </div>
    </div>
    <div class="row" v-if="pls.P !== undefined && pls.P.length > 0">
      <div class="col-xs-12">
        <div class="table-responsive">
          <table class="table table-bordered table-striped" cellspacing="0" width="100%">
            <thead>
              <tr>
                <th style="width: 60%">All Time Total</th>
                <th style="width: 40%" class="text-end">{{ ptotal.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</th>
              </tr>
              <tr>
                <th style="width: 60%">Selected Total</th>
                <th style="width: 40%" class="text-end">{{ pls.T1.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="table-responsive" v-if="pls.D !== undefined && pls.D.length > 0">
      <table class="table table-bordered table-striped" id="earning-report-pdf" cellspacing="0" width="100%" v-if="getw > 767">
        <thead>
          <tr>
            <!-- <th>Match Id</th> -->
            <th>Match Title</th>
            <th class="text-end">Match Earnings</th>
            <th>Start</th>
            <th>End</th>
          </tr>
        </thead>
        <tbody v-if="pls.D">
          <tr v-for="pl in pls.D" :key="pl.I" v-on:click="getd(pl)">
            <!-- <td>{{ pl.I }}</td> -->
            <td>
              <div class="d-flex align-items-center gap-3">
                <div class="">
                  <img :src="'/img/lordlotus/4.png'" alt="" width="20" v-if="pl.Sp === 'Cricket'" />
                  <img :src="'/img/lordlotus/1.png'" alt="" width="20" v-if="pl.Sp === 'Soccer'" />
                  <img :src="'/img/lordlotus/2.png'" alt="" width="20" v-if="pl.Sp === 'Tennis'" />
                  <img :src="'/img/lordlotus/7.png'" alt="" width="20" v-if="pl.Sp === 'Horse Racing'" />
                  <img :src="'/img/lordlotus/4339.png'" alt="" width="20" v-if="pl.Sp === 'Greyhound Racing'" />
                </div>
                <h6 class="mb-0 text-wrap">{{ pl.E }}</h6>
              </div>
              <!-- <Chip :label="pl.E" :image="'/img/lordlotus/4.png'" v-if="pl.Sp === 'Cricket'" style="width: 100%" />
              <Chip :label="pl.E" :image="'/img/lordlotus/1.png'" v-if="pl.Sp === 'Soccer'" style="width: 100%" />
              <Chip :label="pl.E" :image="'/img/lordlotus/2.png'" v-if="pl.Sp === 'Tennis'" style="width: 100%" />
              <Chip :label="pl.E" :image="'/img/lordlotus/7.png'" v-if="pl.Sp === 'Horse Racing'" style="width: 100%" />
              <Chip :label="pl.E" :image="'/img/lordlotus/4339.png'" v-if="pl.Sp === 'Greyhound Racing'" style="width: 100%" /> -->
            </td>
            <td class="text-end">
              <h6 class="mb-0" :class="{ 'text-success': pl.T1 >= 0, 'text-danger': pl.T1 < 0 }">{{ pl.T1.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</h6>
              <!-- <Chip :label="pl.T.toLocaleString()" icon="" v-if="pl.T < 0" class="text-danger" />
              <Chip :label="pl.T.toLocaleString()" icon="" v-if="pl.T > 0" class="text-success" /> -->
            </td>
            <td>
              <div class="d-flex align-items-center gap-3">
                <h6>{{ pl.D }}</h6>
              </div>
              <!-- <Chip :label="pl.D" icon="pi pi-play" /> -->
            </td>
            <td>
              <div class="d-flex align-items-center gap-3">
                <h6>{{ pl.D1 }}</h6>
              </div>
              <!-- <Chip :label="pl.D1" icon="pi pi-stop-circle" /> -->
            </td>
          </tr>
        </tbody>
      </table>
      <div v-for="pl in pls.D" :key="pl.I" v-if="getw < 767" class="mb-2" v-on:click="getd(pl)">
        <div class="d-flex flex-column gap-4">
          <div class="d-flex align-items-center gap-3">
            <div class="social-icon d-flex align-items-center gap-3 flex-grow-1">
              <img :src="'/img/lordlotus/4.png'" alt="" width="20" v-if="pl.Sp === 'Cricket'" />
              <img :src="'/img/lordlotus/1.png'" alt="" width="20" v-if="pl.Sp === 'Soccer'" />
              <img :src="'/img/lordlotus/2.png'" alt="" width="20" v-if="pl.Sp === 'Tennis'" />
              <img :src="'/img/lordlotus/7.png'" alt="" width="20" v-if="pl.Sp === 'Horse Racing'" />
              <img :src="'/img/lordlotus/4339.png'" alt="" width="20" v-if="pl.Sp === 'Greyhound Racing'" />
              <div>
                <h6 class="mb-0 text-wrap">{{ pl.E }}</h6>
                <p class="mb-0">{{ pl.D }}</p>
                <p class="mb-0">{{ pl.D1 }}</p>
              </div>
            </div>
            <h6 class="mb-0" :class="{ 'text-success': pl.T1 >= 0, 'text-danger': pl.T1 < 0 }">{{ pl.T1.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</h6>
            <!-- <div class="card-lable bg-success text-success bg-opacity-10">
                <p class="text-success mb-0">+28.5%</p>
              </div> -->
          </div>
        </div>
        <!-- <div class="wrapper">
          <div>
            <div class="col-xs-12">
              <Chip :label="pl.E" :image="'/img/lordlotus/4.png'" v-if="pl.Sp === 'Cricket'" style="width: 100%" />
              <Chip :label="pl.E" :image="'/img/lordlotus/1.png'" v-if="pl.Sp === 'Soccer'" style="width: 100%" />
              <Chip :label="pl.E" :image="'/img/lordlotus/2.png'" v-if="pl.Sp === 'Tennis'" style="width: 100%" />
              <Chip :label="pl.E" :image="'/img/lordlotus/7.png'" v-if="pl.Sp === 'Horse Racing'" style="width: 100%" />
              <Chip :label="pl.E" :image="'/img/lordlotus/4339.png'" v-if="pl.Sp === 'Greyhound Racing'" style="width: 100%" />
            </div>
            <div class="col-xs-12" style="font-size: 10px; padding-right: 0px; padding-left: 0px">
              <div class="col-xs-5" style="font-size: 10px; padding-right: 0px; padding-left: 0px">
                <span>{{ pl.D }}</span>
              </div>
              <div class="col-xs-1" style="font-size: 10px; padding-right: 0px; padding-left: 0px">-</div>
              <div class="col-xs-5" style="font-size: 10px; padding-right: 0px; padding-left: 0px">
                <span>{{ pl.D1 }}</span>
              </div>
            </div>
            <div class="col-xs-12" style="font-size: 10px; padding-right: 0px; padding-left: 0px">
              <div class="col-xs-6" style="font-size: 10px; padding-right: 0px; padding-left: 0px">
                <b>Match Id:</b> <span>{{ pl.I }}</span>
              </div>
              <div class="col-xs-6 text-center" :class="{ 'text-success': pl.T >= 0, 'text-danger': pl.T < 0 }" style="padding-right: 0px; padding-left: 0px; font-size: 15px">
                <span v-if="pl.T !== 0"><b>{{ pl.T.toLocaleString() }}</b></span>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <Dialog :header="dtshd" v-model:visible="dtssc" :dialog="true" :style="{ width: '100vw', height: '100vh' }">
      <div class="d-flex flex-column gap-4 p-2" v-for="dt in dts" :key="dt.I" v-on:click="getpld(dt)">
        <div class="d-flex align-items-center gap-3">
          <div class="social-icon d-flex align-items-center gap-3 flex-grow-1">
            <div class="social-icon d-flex align-items-center gap-3 flex-grow-1">
              <!-- <img :src="'/img/lordlotus/4.png'" alt="" v-if="dtssp === 'Cricket'" width="40" />
              <img :src="'/img/lordlotus/1.png'" alt="" v-if="dtssp === 'Soccer'" width="40" />
              <img :src="'/img/lordlotus/2.png'" alt="" v-if="dtssp === 'Tennis'" width="40" />
              <img :src="'/img/lordlotus/7.png'" alt="" v-if="dtssp === 'Horse Racing'" width="40" />
              <img :src="'/img/lordlotus/4339.png'" alt="" v-if="dtssp === 'Greyhound Racing'" width="40" /> -->
              <div>
                <h6 class="mb-0 text-wrap">{{ dt.M }}</h6>
              </div>
            </div>
          </div>
          <h4 class="mb-0" :class="{ 'text-success': dt.T >= 0, 'text-danger': dt.T < 0 }">{{ dt.T.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</h4>
        </div>
      </div>
      <!-- <div class="table-responsive">
        <table class="table" cellspacing="0" width="100%">
          <tbody>
            <tr v-for="dt in dts" :key="dt.I" v-on:click="getpld(dt)">
              <td>{{ dt.M }}</td>
              <td class="text-end" :class="{ 'text-success': dt.T >= 0, 'text-danger': dt.T < 0 }">
                <Chip :label="dt.T.toLocaleString()" icon="pi pi-times" v-if="dt.T < 0" class="text-danger" />
                <Chip :label="dt.T.toLocaleString()" icon="pi pi-check" v-if="dt.T > 0" class="text-success" />
              </td>
            </tr>
          </tbody>
        </table>
      </div> -->
    </Dialog>
    <Dialog header="" v-model:visible="showpl" :dialog="true" :style="{ width: '100vw', height: '100vh' }" :maximizable="maximum">
      <div class="container-fluid">
        <div class="animated fadeIn">
          <div class="col-xs-12">
            <div class="card">
              <div class="card-header">
                <button type="button" class="btn btn-sm btn-primary" v-on:click="closepl()">Back&nbsp;</button>
                <strong>{{ cpld.E }}&nbsp;</strong>
                <span class="badge badge-warning" style="font-size: 100%" v-if="cpld.N"> {{ cpld.N }} </span>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-6">
                    <table class="table table-bordered table-striped table-sm">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th class="text-end">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="i in cpld.comusersl" :key="i.N">
                          <td>
                            <strong>
                              <span v-if="!shows(i.N)">{{ i.N }}</span>
                              <a v-if="shows(i.N)" href="javascript:void(0);" v-on:click="openpl(i.I, i.N, i.T === 16, cpld.E)" :class="{ 'btn-grd-primary ': i.T !== 16, 'btn-grd-royal ': i.T === 16 }" :disabled="i.N === cpld.N">{{ i.N }}</a>
                            </strong>
                          </td>
                          <td class="text-end" :class="{ 'text-success': i.A >= 0, 'text-danger': i.A < 0 }">{{ i.A.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-6">
                    <table class="table table-bordered table-striped table-sm">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th class="text-end">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="i in cpld.comusersr" :key="i.N">
                          <td>
                            <strong>
                              <span v-if="!shows(i.N)">{{ i.N }}</span>
                              <a v-if="shows(i.N)" href="javascript:void(0);" v-on:click="openpl(i.I, i.N, i.T === 16, cpld.E)" :class="{ 'btn-grd-primary ': i.T !== 16, 'btn-grd-royal ': i.T === 16 }" :disabled="i.N === cpld.N">{{ i.N }}</a>
                            </strong>
                          </td>
                          <td class="text-end" :class="{ 'text-success': i.A >= 0, 'text-danger': i.A < 0 }">{{ i.A.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <table class="table table-sm">
                      <tbody>
                        <tr>
                          <th>Total</th>
                          <th :class="{ 'text-success': cpld.totall >= 0, 'text-danger': cpld.totall < 0 }">{{ cpld.totall.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-6">
                    <table class="table table-sm">
                      <tbody>
                        <tr class="">
                          <td>Total</td>
                          <th :class="{ 'text-success': cpld.totalr >= 0, 'text-danger': cpld.totalr < 0 }">{{ cpld.totalr.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="" v-model:visible="showpl1" :dialog="true" :style="{ width: '100vw', height: '100vh' }" :maximizable="maximum">
      <div class="container-fluid">
        <div class="animated fadeIn">
          <div class="row col-12">
            <div class="card">
              <div class="card-header">
                <button type="button" class="btn btn-sm btn-primary" v-on:click="closepl1()">Back&nbsp;</button>
                <strong>{{ cpld1.E }}&nbsp;</strong>
                <span class="badge badge-warning" style="font-size: 100%"> {{ cpld1.N }} </span>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-6">
                    <table class="table table-bordered table-striped table-sm">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="i in cpld1.comusersl" :key="i.N">
                          <td>
                            <strong>
                              <span v-if="!shows(i.N) && i.N !== cpld1.N">{{ i.N }}</span>
                              <a v-if="shows(i.N)" href="javascript:void(0);" v-on:click="openpl(i.I, i.N, i.T === 16, cpld1.N)" :class="{ 'btn-grd-primary ': i.T !== 16, 'btn-grd-royal ': i.T === 16 }" :disabled="i.N === cpld1.N">{{ i.N }}</a>
                            </strong>
                          </td>
                          <td :class="{ 'text-success': i.A >= 0, 'text-danger': i.A < 0 }">{{ i.A.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-6">
                    <table class="table table-bordered table-striped table-sm">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="i in cpld1.comusersr" :key="i.N">
                          <td>
                            <strong>
                              <span v-if="!shows(i.N)">{{ i.N }}</span>
                              <a v-if="shows(i.N)" href="javascript:void(0);" v-on:click="openpl(i.I, i.N, i.T === 16, cpld1.N)" :class="{ 'btn-grd-primary ': i.T !== 16, 'btn-grd-royal ': i.T === 16 }" :disabled="i.N === cpld1.N">{{ i.N }}</a>
                            </strong>
                          </td>
                          <td :class="{ 'text-success': i.A >= 0, 'text-danger': i.A < 0 }">{{ i.A.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <table class="table table-sm">
                      <tbody>
                        <tr>
                          <th>Total</th>
                          <th :class="{ 'text-success': cpld1.totall >= 0, 'text-danger': cpld1.totall < 0 }">{{ cpld1.totall.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-6">
                    <table class="table table-sm">
                      <tbody>
                        <tr class="">
                          <td>Total</td>
                          <th :class="{ 'text-success': cpld1.totalr >= 0, 'text-danger': cpld1.totalr < 0 }">{{ cpld1.totalr.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="" v-model:visible="showbets" :dialog="true" :style="{ width: '100vw', height: '100vh' }" :maximizable="maximum">
      <div class="row" v-if="bets.N !== undefined">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-header">
              <h5>
                <button type="button" class="btn btn-sm btn-primary" v-on:click="showbets = false">Back</button>
                {{ bets.Ev }}
              </h5>
            </div>
            <div class="card-body">
              <table class="table">
                <tbody>
                  <tr>
                    <th>
                      Winner
                      <span class="badge badge-secondary text-dark" style="font-size: 100%"> {{ bets.W }} </span>
                    </th>
                  </tr>
                  <tr>
                    <th>
                      Net PL
                      <span class="badge text-dark" style="font-size: 100%" :class="{ 'badge-danger': bets.P < 0, 'badge-info': bets.P > 0 }"> {{ bets.P.toLocaleString(undefined, { minimumFractionDigits: 2 }) }} </span>
                    </th>
                  </tr>
                  <tr>
                    <th>
                      UserName
                      <span class="badge badge-secondary text-dark" style="font-size: 100%"> {{ bets.N }} </span>
                    </th>
                  </tr>
                </tbody>
              </table>
              <DataTable :value="bets.B" :rows="100" :paginator="true" responsiveLayout="scroll" filterDisplay="menu" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" :rowsPerPageOptions="[10, 25, 50, 100]" paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" v-if="bets.B.length > 0" showGridlines stripedRows>
                <Column field="Ma" header="Runner" sortable></Column>
                <Column field="O" header="Price" sortable>
                  <template #body="S">
                    <span v-if="S.data.Type === 'Y' || S.data.Type === 'N'">{{ S.data.SId }}/</span>{{ S.data.O.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}
                  </template>
                </Column>
                <Column field="A" header="Size" sortable>
                  <template #body="S">
                    {{ S.data.A.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}
                  </template>
                </Column>
                <Column field="Type" header="Side" sortable>
                  <template #body="S">
                    <button class="btn btn-sm btn-block" :class="{ 'bg-info': S.data.Type === 'B' || S.data.Type === 'Y', 'bg-danger': S.data.Type === 'L' || S.data.Type === 'N' }">{{ S.data.Type }}</button>
                  </template>
                </Column>
                <Column field="P" header="P/L" sortable>
                  <template #body="S">
                    <span :class="{ 'text-danger': S.data.P < 0, 'text-success': S.data.P >= 0 }">{{ S.data.P.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</span>
                  </template>
                </Column>
                <!-- <Column field="W2" header="Placed At" sortable></Column> -->
                <Column field="W4" header="Matched At" sortable></Column>
                <Column field="W5" header="Settled At" sortable></Column>
                <Column field="N" header="Punter" sortable></Column>
                <Column field="H" header="Dealer" sortable></Column>
                <Column field="Nr" header="Order-Id" sortable></Column>
                <Column field="Pmt" header="FullOdds" sortable></Column>
                <Column field="Ip" header="Ip" sortable>
                  <template #body="S">
                    <a href="javascript:void(0);" v-on:click="showipd(S.data.Ip)">
                      <b>{{ S.data.Ip }}</b>
                    </a>
                  </template>
                </Column>
                <Column field="Did" header="Device" sortable>
                  <template #body="S">
                    <a href="javascript:void(0);" v-on:click="showdeviced(S.data.Did)">
                      <b>{{ S.data.Did }}</b>
                    </a>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog v-model:visible="showip" :dialog="true" :maximizable="maximum" style="width: 95%; height: 95%">
      <iframe style="width: 95vw; height: 95vh" :src="'https://www.magurano.eu/whats-my-ip-free?ip=' + ip"></iframe>
    </Dialog>
    <Dialog v-model:visible="showdevice" :dialog="true" :maximizable="maximum" style="width: 95%; height: 95%">
      <iframe style="width: 95vw; height: 95vh" :src="'https://www.magurano.eu/device?id=' + did"></iframe>
    </Dialog>
  </BlockUI>
</template>

<script>
import $$vm from "@/data/index";
import MultiSelect from "primevue/multiselect";
import Datepicker from "@vuepic/vue-datepicker";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";
import BlockUI from "primevue/blockui";
import Chip from "primevue/chip";
import Dialog from "primevue/dialog";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

import { endOfMonth, endOfYear, startOfMonth, startOfYear, subMonths, add, endOfWeek, subWeeks, startOfWeek, setDefaultOptions } from "date-fns";

export default {
  name: "ProfitAndLoss1",
  components: {
    MultiSelect,
    Datepicker,
    Dropdown,
    Button,
    BlockUI,
    Chip,
    Dialog,
    DataTable,
    Column,
  },
  data() {
    return {
      proc: false,
      page: 0,
      size: 50,
      total: 0,
      gtotal: 0,
      ptotal: 0,
      pls: {},
      dts: [],
      dtssc: false,
      dtshd: "",
      dtssp: "",
      getw: 0,
      sp: "",
      maximum: true,
      showpl: false,
      showpl1: false,
      cpld: {},
      cpld1: {},
      cpldall: [],
      cpldallid: 0,
      showbets: false,
      bets: {},
      showip: false,
      showdevice: false,
      did: "",
      ip: "",
      name: "",
      // format: "dd-MM-yyyy - dd-MM-yyyy",
      cities: [
        { name: "Today", code: "T" },
        { name: "Yesterday", code: "Y" },
        { name: "Last 7 Days", code: "L7D" },
        { name: "This Week", code: "TW" },
        { name: "Last Week", code: "LW" },
        { name: "Last 30 Days", code: "L30D" },
        { name: "This Month", code: "TM" },
        { name: "Last Month", code: "LM" },
      ],
      sel: [
        { b: "Cricket", value: "Cricket" },
        { b: "Soccer", value: "Soccer" },
        { b: "Tennis", value: "Tennis" },
        { b: "Horse Racing", value: "Horse Racing" },
        { b: "Greyhound Racing", value: "Greyhound Racing" },
      ],
      sps: [
        { b: "Cricket", value: "Cricket" },
        { b: "Soccer", value: "Soccer" },
        { b: "Tennis", value: "Tennis" },
        { b: "Horse Racing", value: "Horse Racing" },
        { b: "Greyhound Racing", value: "Greyhound Racing" },
      ],
      startdate: new Date(),
      enddate: new Date(),
      maxd: new Date(),
      date: [],
      presetRanges: [
        { label: "Today", range: [new Date(), new Date()] },
        { label: "Yesterday", range: [add(new Date(), { days: -1 }), add(new Date(), { days: -1 })] },
        { label: "Last 7 Days", range: [add(new Date(), { days: -6 }), new Date()] },
        { label: "This Week", range: [startOfWeek(new Date(), { weekStartsOn: 1 }), new Date()] },
        { label: "Last Week", range: [startOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 }), endOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 })] },
        { label: "Last 30 Days", range: [add(new Date(), { days: -29 }), new Date()] },
        { label: "This month", range: [startOfMonth(new Date()), endOfMonth(new Date())] },
        {
          label: "Last month",
          range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
        },
        { label: "This year", range: [startOfYear(new Date()), endOfYear(new Date())] },
      ],
    };
  },
  mounted() {
    var self = this;
    self.enddate = new Date();
    self.startdate = new Date();
    self.date = [this.startdate, this.enddate];
    self.update();
    self.getw = $(window).width();
    $(window).resize(function () {
      self.getw = $(window).width();
    });
  },
  computed: {
    getN: function () {
      return $$vm.bala.U;
    },
  },
  methods: {
    update: function () {
      var self = this;
      self.maxd = new Date();
      if (self.$route.params.id !== undefined && self.$route.params.id !== self.name1) {
        self.name1 = self.$route.params.id;
        self.getpl();
      }
      setTimeout(function () {
        self.update();
      }, 1000);
      // var self = this;
      // if (self.getN === undefined) {
      //   setTimeout(self.update, 200);
      // } else {
      //   self.name = self.getN;
      // }
    },
    shows: function (a) {
      if (a === this.name || a === "book") {
        return false;
      }
      return true;
    },
    update: function () {
      var self = this;
      self.maxd = new Date();
      if (self.$route.name === "") {
        setTimeout(function () {
          self.update();
        }, 1000);
      }
    },
    getpl: function () {
      var self = this;
      if (self.sel.length === 0) {
        toastr["error"]("Please Select Sport");
        return;
      }
      self.sp = "";
      self.sel.forEach((el) => {
        self.sp += el.value + ",";
      });
      var cd = new Date();
      if (self.enddate > cd) {
        self.enddate = cd;
      }
      if (self.enddate < self.startdate) {
        self.enddate = self.startdate;
      }
      self.startdate = self.date[0];
      self.enddate = self.date[1];
      var from = self.startdate.getFullYear() + "-" + (self.startdate.getMonth() + 1) + "-" + self.startdate.getDate() + " 00:00";
      var to = self.enddate.getFullYear() + "-" + (self.enddate.getMonth() + 1) + "-" + self.enddate.getDate() + " 23:59";
      if ($$vm.cn) {
        self.pls = {};
        self.total = 0;
        self.proc = true;
        $$vm.c.invoke("getplbsf", self.sp, from, to, (self.page * self.size).toString(), self.size.toString(), "").then(
          function (data) {
            data = $$vm.decompress(data);
            self.pls = data;
            self.total = data.T;
            $.each(self.pls.D, function (ii, jj) {
              jj["D"] = moment($$vm.cutl3(jj["D"])).format("DD/MM/YYYY HH:mm:ss");
              jj["D1"] = moment($$vm.cutl3(jj["D1"])).format("DD/MM/YYYY HH:mm:ss");
            });
            self.proc = false;
            self.ptotal = 0;
            var sps = self.sp.split(",");
            $.each(sps, function (oo, pp) {
              $.each(self.pls.P, function (oo1, pp1) {
                if (pp1.S === pp || (pp === "Cricket" && pp1.S === "Fancy")) {
                  self.ptotal += pp1["T"];
                }
              });
            });
          },
          function (err) {
            self.proc = false;
          }
        );
      } else {
        toastr["error"]("Not Connected to Server");
      }
    },
    getd: function (did) {
      var self = this;
      if ($$vm.cn) {
        self.dtshd = did.E + " (" + did.T.toLocaleString() + ")";
        //console.log(did);
        self.dtssp = did.Sp;
        self.proc = true;
        //console.log(did.I.toString());
        $$vm.c.invoke("getplbsfm", did.I.toString(), "").then(
          function (data) {
            data = $$vm.decompress(data);
            //console.log(data);
            self.dts = data;
            self.dtssc = true;
            self.proc = false;
          },
          function (err) {
            console.log(err);
            self.proc = false;
          }
        );
      } else {
        toastr["error"]("Not Connected to Server");
      }
    },
    getpld: function (did) {
      //console.log(did);
      var self = this;
      var id = { id: did.I, N: "" };
      var id1 = $$vm.compress1(JSON.stringify(id));
      if ($$vm.cn) {
        self.proc = true;
        $$vm.c.invoke("getplbsfms", id1, "", "").then(
          function (data) {
            var new1 = { comusersl: [], comusersr: [], totall: 0, totalr: 0, N: "", E: did.M };
            data = $$vm.decompress(data);
            //console.log(data);
            $.each(data, function (ii, jj) {
              if (jj["A"] < 0) {
                new1.comusersr.push(jj);
                new1.totalr += jj["A"];
              } else {
                new1.comusersl.push(jj);
                new1.totall += jj["A"];
              }
            });
            var net = -1 * (new1.totall - Math.abs(new1.totalr));
            if (net !== 0) {
              if (net >= 0) {
                new1.comusersl.push({ N: "book", A: net });
                new1.totall += net;
              } else {
                new1.comusersr.push({ N: "book", A: net });
                new1.totalr += net;
              }
            }
            self.cpld = new1;
            self.showpl = true;
            self.proc = false;
          },
          function (err) {
            console.log(err);
            self.proc = false;
          }
        );
      }
    },
    openpl: function (id, n, d, d1) {
      var self = this;
      if (n === d1) {
        self.closepl1();
        return;
      }
      if (id < 0) {
        return;
      }
      if (d) {
        self.getbets(id);
        return;
      }
      var id = { id: id, N: n };
      var id1 = JSON.stringify(id);
      if ($$vm.cn) {
        self.blockdates = true;
        $$vm.c.invoke("getplbsfms", $$vm.compress1(id1), "", "").then(
          function (data) {
            if (data !== undefined && data !== null) {
              data = $$vm.decompress(data);
              var new1 = { comusersl: [], comusersr: [], totall: 0, totalr: 0, N: n, E: d1 };
              $.each(data, function (ii, jj) {
                if (jj["A"] < 0) {
                  new1.comusersr.push(jj);
                  new1.totalr += jj["A"];
                } else {
                  new1.comusersl.push(jj);
                  new1.totall += jj["A"];
                }
              });
              // if (data["A"] < 0) {
              //   new1.comusersr.push({ N: data["N"], A: data["A"], D: false });
              //   new1.totalr += data["A"];
              // } else {
              //   new1.comusersl.push({ N: data["N"], A: data["A"], D: false });
              //   new1.totall += data["A"];
              // }
              var net = -1 * (new1.totall - Math.abs(new1.totalr));
              if (net !== 0) {
                if (net >= 0) {
                  new1.comusersl.push({ N: "book", A: net });
                  new1.totall += net;
                } else {
                  new1.comusersr.push({ N: "book", A: net });
                  new1.totalr += net;
                }
              }
              self.cpldall.push(new1);
              self.cpld1 = new1;
              self.cpldallid = id;
            }
            self.blockdates = false;
            self.showpl1 = true;
          },
          function (err) {
            self.blockdates = false;
          }
        );
      }
    },
    closepl: function () {
      this.cpld = {};
      this.showpl = false;
    },
    closepl1: function () {
      var a = this.cpldall.pop();
      if (a === undefined) {
        this.showpl1 = false;
      } else {
        this.cpld1 = a;
      }
    },
    getbets: function (id) {
      console.log(id);
      var self = this;
      if ($$vm.cn) {
        self.blockdates = true;
        $$vm.c.invoke("bd", id.toString()).then(
          function (data) {
            data = $$vm.decompress(data);
            console.log(data);
            data["W1"] = $$vm.cutl3(data["S"]);
            data["W2"] = moment(data["W1"]).format("M/D/YYYY hh:mm:ss A");
            $.each(data.B, function (ii, jj) {
              jj["W1"] = $$vm.cutl3(jj["D"]);
              jj["W2"] = moment(jj["W1"]).format("M/D/YYYY hh:mm:ss A");
              jj["W3"] = $$vm.cutl3(jj["D1"]);
              jj["W4"] = moment(jj["W3"]).format("M/D/YYYY hh:mm:ss A");
              jj["W5"] = data["W2"];
              if (jj["T"] === 0) {
                jj["Type"] = "B";
              } else if (jj["T"] === 1) {
                jj["Type"] = "L";
              } else if (jj["T"] === 2) {
                jj["Type"] = "Y";
              } else {
                jj["Type"] = "N";
              }
            });
            self.bets = data;
            self.showbets = true;
            self.blockdates = false;
          },
          function (err) {
            console.log(err);
            self.blockdates = false;
          }
        );
      }
    },
    showipd: function (ip) {
      var self = this;
      if (ip !== undefined && ip !== null && ip.length > 0) {
        self.ip = ip;
        self.showip = true;
      }
    },
    showdeviced: function (did) {
      var self = this;
      if (did !== undefined && did !== null && did > 0) {
        self.did = did;
        self.showdevice = true;
      }
    },
  },
};
</script>

<style></style>
